/**
 * Copyright (c) 2024 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// load these polyfills before any pvd components
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js';
import '@webcomponents/webcomponentsjs/webcomponents-bundle.js';

import 'pvd3/dist/legacy-browsers/polyfills.min.js';

// global styles
import './scss/main.scss';

import {
    injectSpriteSheet,
    PvdAlert,
    PvdButton,
    PvdContentBlock,
    PvdExpandCollapse,
    PvdFieldGroup,
    PvdIcon,
    PvdInlineAlert,
    PvdInput,
    PvdLabel,
    PvdLink,
    PvdListGroup,
    PvdMicrocopy,
    PvdModal,
    PvdPopover,
    PvdProgressIndicator,
    PvdSpinner,
    PvdTitle,
    PvdTooltip
} from 'pvd3';
import { ApexCurrency } from '@fmr-pr103625/apex-currency';

const APEX_NAMESPACE = 'apex3';
const PROVIDENCE_NAMESPACE = 'pvd3';
injectSpriteSheet(PROVIDENCE_NAMESPACE);
PvdAlert.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdButton.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdContentBlock.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdExpandCollapse.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdFieldGroup.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdIcon.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdInlineAlert.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdInput.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdLabel.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdLink.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdListGroup.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdMicrocopy.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdModal.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdPopover.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdProgressIndicator.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdSpinner.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdTitle.defineCustomElement(PROVIDENCE_NAMESPACE);
PvdTooltip.defineCustomElement(PROVIDENCE_NAMESPACE);
ApexCurrency.defineCustomElement(APEX_NAMESPACE, PROVIDENCE_NAMESPACE);

createApp(App).use(router).mount('#app');
